import { Box, Section, Spinner, useToggle } from '@factorialco/deprecated-design-system'
import { AtsMessageTemplatesPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { MessageTemplatesDataTable } from './MessageTemplatesDataTable'
import { NewMessageTemplateModal } from './NewMessageTemplateModal'

export const MessageTemplates = () => {
  const [showCreateModal, toggleCreateModal] = useToggle(false)
  const { data, loading } = useQuery(AtsMessageTemplatesPageDocument)

  const canManageCompanyMessageTemplates =
    data?.ats._policies.messageTemplatesManageCompanyMessageTemplates.can || false

  if (loading) {
    return (
      <Box alignItems="center" paddingY="s16">
        <Spinner />
      </Box>
    )
  }

  return (
    <>
      <Section
        illustration="send-email-envelope"
        title={i18n.t('ats.manage_message_templates.title')}
        description={i18n.t('ats.manage_message_templates.description')}
        link={{
          label: i18n.t('common.learn_more'),
          href: i18n.t('ats.manage_message_templates.help_center_url'),
        }}
        action={{
          onClick: toggleCreateModal(true),
          label: i18n.t('ats.manage_message_templates.add_template'),
        }}
      />
      <Box paddingX="s64" paddingBottom="s32">
        <MessageTemplatesDataTable
          canManageCompanyMessageTemplates={canManageCompanyMessageTemplates}
        />
      </Box>

      {showCreateModal && <NewMessageTemplateModal onClose={toggleCreateModal(false)} />}
    </>
  )
}
